import { useFormik } from 'formik';
import React from 'react';
import { useState } from 'react';
import { BookButton, BookModal, BookTexField } from '../../components';
import { languageValidation } from '../languages/validation';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { CreateLaguage, UpdateLaguage } from "../../DAL/Language/language";
import { enqueueSnackbar } from "notistack";

const LanguageModal = ({
  open,
  setOpen,
  action,
  singleLanguage,
  tableCells,
  handleGetLanguageData,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.up('sm'));

  const handleAddLanguage = async(values) => {
    setIsLoading(true);
    const data = {
      name: values?.name,
      direction: values?.direction
    };
    const response = await CreateLaguage(data);
    if (response.statusCode == 200) {
      setIsLoading(false);
      handleGetLanguageData()
      setOpen(false);
      formik.handleReset();
    } else {
      setIsLoading(false);
      if (typeof response.message == "string") {
        enqueueSnackbar(response.message, { variant: "error" });
      } else {
        enqueueSnackbar("Invalid credentials", { variant: "error" });
      }
    }
  };

  const handleUpdateLanguage = async(values) => {  
    setIsLoading(true);
    const data = {
      name: values?.name,
      direction: values?.direction
    };
    const response = await UpdateLaguage(values?.id, data);
    if (response.statusCode == 200) {
      setIsLoading(false);
      handleGetLanguageData()
      setOpen(false);
      formik.handleReset();
    } else {
      setIsLoading(false);
      if (typeof response.message == "string") {
        enqueueSnackbar(response.message, { variant: "error" });
      } else {
        enqueueSnackbar("Invalid credentials", { variant: "error" });
      }
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: 
        action !== 'add' && singleLanguage && singleLanguage.id
        ? singleLanguage.id
        : '',
      name:
        action !== 'add' && singleLanguage && singleLanguage.name
          ? singleLanguage.name
          : '',
        direction:
        action !== 'add' && singleLanguage && singleLanguage.direction
          ? singleLanguage.direction
          : '',
    },
    validationSchema: languageValidation,
    onSubmit: values => {
      setIsLoading(true);
      if (action === 'add') {
        handleAddLanguage(values);
      } else {
        handleUpdateLanguage(values);
      }
    },
  });

  return (
    <BookModal
      open={open}
      formik={formik}
      setOpen={setOpen}
      title='Language'
      subtitle={`${action === 'add' ? 'Add' : 'Edit'} Language`}
    >
      {tableCells &&
        tableCells.map(
          t =>
            t.id !== 'actions' &&
             (
              <BookTexField
                formik={formik}
                name={t.id}
                label={t.title}
                placeholder={`Enter ${t.title}`}
                key={t.id + 'cell'}
              />
            )
        )}
      <BookButton
        onSubmit={formik.handleSubmit}
        title={`${action === 'add' ? 'Add' : 'Update'}`}
        type='primary'
        variant='contained'
        isLoading={isLoading}
        sx={{
          top: '0.625rem',
          marginBottom: '0.625rem'
        }}
      />
    </BookModal>
  );
};

export default LanguageModal;



  